import * as React from 'react';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import ReviewScore from 'components/FormControls/ReviewScore';
import ReviewList from 'components/ItemList/ReviewList';
import { IStore } from 'redux/IStore';
import ShopReviewBox from 'components/FormControls/ShopReviewBox';
import { getShopReviews } from 'redux/modules/shop/shopreviews';
import { IShopReviewsData } from 'models/shop/shopreviews';
const { connect } = require('react-redux');

interface IProps {
	userId: string;
	t?: (key: string) => string;
	shopReviews: IShopReviewsData;
	officeLocation: string;

	// state props
	averageRating?: number;
	votes?: number;
	shopId?: string;

	getShopReviews?: (shopId: string, isFirstLoad: boolean) => void;
}

let gotShopReviews = false;

@connect(
	(state: IStore) => ({
		averageRating: state.shopcard.shopcard.averageRating,
		votes: state.shopcard.shopcard.votes,
		shopId: state.shopcard.shopcard.id,
		shopReviews: state.shopReviews,
	}),
	(dispatch) => ({
		getShopReviews: (shopId: string, isFirstLoad: boolean) => dispatch(getShopReviews(shopId, isFirstLoad)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopReviews extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}

	componentDidUpdate() {
		if (
			!this.props.shopReviews.items.length &&
			!this.props.shopReviews.isFetching &&
			this.props.shopId &&
			!gotShopReviews
		) {
			gotShopReviews = true;
			this.props.getShopReviews(this.props.shopId, true);
		}
	}

	componentWillUnmount(): void {
		gotShopReviews = false;
	}

	render() {
		const { averageRating, votes } = this.props;
		// TODO Show ReviewBox only to shops that can leave review to the customer
		return (
			<div className="reviews">
				<div className="reviews-score-row flex-d row justify-content-between align-items-center">
					<h3 className="reviews-location">{this.props.officeLocation}</h3>
					<ReviewScore averageRating={averageRating} votes={votes} />
				</div>
				<ShopReviewBox />
				<ReviewList items={this.props.shopReviews.items} />
			</div>
		);
	}
}

export default withAuthContext(ShopReviews);
